import styles from "./SummaryFooter.module.scss";
import { DefaultButton } from "../../../../button/defaultButton/DefaultButton";
import { Icon, IconType } from "../../../../../icons/Icon";

interface ISummaryFooterProps {
  employeeName?: string;
  dateTime: { date: string; time: string } | null;
  canConfirm: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const Fragment = ({
  icon,
  value,
  placeholder,
}: {
  icon: IconType;
  value?: string;
  placeholder: string;
}) => (
  <div className={styles.fragment}>
    <Icon type={icon} color="rgba(255,255,255,0.6)" />
    <span
      className={value ? styles.fragment_value : styles.fragment_placeholder}
    >
      {value || placeholder}
    </span>
  </div>
);

export const SummaryFooter = ({
  employeeName,
  dateTime,
  canConfirm,
  onConfirm,
  onCancel,
}: ISummaryFooterProps) => {
  return (
    <div className={styles.footer}>
      <div className={styles.summary}>
        <Fragment
          icon={IconType.Person}
          value={employeeName}
          placeholder="Служител"
        />
        <span className={styles.separator}>·</span>
        <Fragment
          icon={IconType.Calendar}
          value={dateTime?.date}
          placeholder="Дата"
        />
        <span className={styles.separator}>·</span>
        <Fragment
          icon={IconType.ClockIcon}
          value={dateTime?.time}
          placeholder="Час"
        />
      </div>

      <div className={styles.actions}>
        <DefaultButton
          design="outline"
          label="Отказ"
          onClick={onCancel}
          width="auto"
        />
        <DefaultButton
          design="accent"
          label="Потвърди"
          onClick={onConfirm}
          disabled={!canConfirm}
          width="auto"
        />
      </div>
    </div>
  );
};
